/**
 * Sidebar navigation items for the Jobs module.
 * Provides navigation to dispatch, timeline, calendar, map overview, and job sites.
 * Navigation items are feature-flag gated.
 */
import { Work, WorkOutline } from '@mui/icons-material';

import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';

export interface JobsNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const JobsNavItems = (): JobsNavItemsResult => {
  const navItems: NavItemType = {
    id: 'jobs',
    title: 'Jobs',
    type: 'collapse',
    icon: WorkOutline,
    iconSelected: Work,
    url: '/jobs?module=jobs',
    children: [
      {
        id: 'dispatch',
        title: 'Dispatch',
        type: 'item',
        url: '/jobs?module=jobs&submodule=dispatch',
        featureFlag: FEATURE_FLAGS.JOBS_DISPATCH_TAB
      },
      {
        id: 'timeline',
        title: 'Timeline',
        type: 'item',
        url: '/jobs?module=jobs&submodule=timeline',
        featureFlag: FEATURE_FLAGS.JOBS_TIMELINE_TAB
      },
      {
        id: 'calendar',
        title: 'Calendar',
        type: 'item',
        url: '/jobs?module=jobs&submodule=calendar',
        featureFlag: FEATURE_FLAGS.JOBS_CALENDAR_TAB
      },

      {
        id: 'mapOverview',
        title: 'Map Overview',
        type: 'item',
        url: '/jobs?module=jobs&submodule=mapOverview',
        featureFlag: FEATURE_FLAGS.JOBS_MAP_OVERVIEW_TAB
      },
      {
        id: 'jobSites',
        title: 'Job Sites',
        type: 'item',
        url: '/jobs?module=jobs&submodule=jobSites',
        featureFlag: FEATURE_FLAGS.JOBSITES_MODULE_ENABLED
      }
    ]
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default JobsNavItems;
